import Link from 'next/link';
import { BsStar, BsStarFill } from 'react-icons/bs';

export default function FavouriteButton({ onClick, current }) {
    return (
        <>
            <button onClick={onClick} className={`flex items-center text-center flex-row font-BreezeButton gap-x-2 text-xs leading-tight px-4 py-2 ${current ? "bg-yellow-200 text-black" : "bg-yellow-400 hover:bg-yellow-300"} active:shadow-lg transition-colors duration-500 ease-in-out uppercase text-sp text-black rounded-full`}>
                { current ? <BsStarFill className="w-6 h-4" /> : <BsStar className="w-6 h-4" /> }
                Featured
            </button>
        </>
    )
};